/**
 * Admin utility functions
 */

// Admin email stored in environment
const ADMIN_EMAIL = 'georgemfarnell@gmail.com'

/**
 * Check if a user is an admin (client-side check)
 * Note: Always verify server-side as well!
 */
export function isAdmin(userEmail: string | undefined): boolean {
  if (!userEmail) return false
  return userEmail.toLowerCase() === ADMIN_EMAIL.toLowerCase()
}

/**
 * Verify admin access server-side
 */
export async function verifyAdminAccess(accessToken: string): Promise<boolean> {
  try {
    const baseUrl = import.meta.env.VITE_API_BASE_URL || window.location.origin
    const response = await fetch(`${baseUrl}/api/admin/verify`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
      },
    })

    if (!response.ok) {
      return false
    }

    const data = await response.json()
    return data.isAdmin === true
  } catch (error) {
    console.error('Error verifying admin access:', error)
    return false
  }
}
